import { useParams } from 'react-router-dom';

const useGetEditUserIdFromPathname = (): string | undefined => {
	const { userId } = useParams<{ userId: string }>();
	return userId;
};

export default useGetEditUserIdFromPathname;
